import React from 'react';
import { Message, useMessage } from '@messageformat/react';
import { Action, Col, Row } from '@op/opds.opux';

import LanguageSelection from '../LanguageSelection';

const MiddleColumn: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    return (
        <Col xs={12} lg={2}>
            {children}
        </Col>
    );
};

const Footer: React.FC<{}> = () => {
    return (
        <footer className='ec-page-footer' role='contentinfo'>
            <Row around>
                <Col xs={12} lg={1} className='ec-language-selection'>
                    <LanguageSelection />
                </Col>
                <Col xs={12} lg={8}>
                    <Row className='ec-footer-links' around end>
                        <MiddleColumn>
                            <Action
                                href={useMessage('Link_Data_Protection', {})}
                                inline
                                className='ec-action'>
                                <Message id='Phrase_Data_Protection' />
                            </Action>
                        </MiddleColumn>
                        <MiddleColumn>
                            <Action
                                href={useMessage('Link_Accessibility', {})}
                                inline
                                className='ec-action'>
                                <Message id='Phrase_Accessibility' />
                            </Action>
                        </MiddleColumn>
                        <MiddleColumn>
                            <Action
                                href={useMessage('Link_Terms_Of_Use', {})}
                                inline
                                className='ec-action'>
                                <Message id='Phrase_Terms_Of_Use' />
                            </Action>
                        </MiddleColumn>
                        <MiddleColumn>
                            <Action
                                href={useMessage(
                                    'Link_Terms_And_Condition',
                                    {},
                                )}
                                inline
                                className='ec-action'>
                                <Message id='Phrase_Terms_And_Condition' />
                            </Action>
                        </MiddleColumn>
                        <MiddleColumn>
                            <Action
                                href={useMessage('Link_Use_Of_Cookies', {})}
                                inline
                                className='ec-action'>
                                <Message id='Phrase_Use_Of_Cookies' />
                            </Action>
                        </MiddleColumn>
                    </Row>
                </Col>
                <Col className='ec-copyright' xs={12} lg={1}>
                    <Message id='Phrase_Copyright' />
                </Col>
            </Row>
        </footer>
    );
};

Footer.displayName = 'Footer';
export default Footer;
